import BaseService from '@/ecm/common/BaseService.js';
import Utils from '@/ecm/common/Utils.js';

class AccessRightService {
  baseUrl = 'access-right';

  getGrid = () => Utils.grid.getParameters(`${this.baseUrl}/get-grid`);
  getList = () => BaseService.get({ url: `${this.baseUrl}` });
  delete = (id) => BaseService.delete({ url: `${this.baseUrl}/${id}` });
  save = (user) => BaseService.post({ url: `${this.baseUrl}`, data: user });
  getById = (id) => BaseService.get({ url: `${this.baseUrl}/${id}` });
}

export default new AccessRightService();
